// extracted by mini-css-extract-plugin
export default {"container":"Room_container__28Rr4","top":"Room_top__y+G4u","button":"Room_button__eIf8V","link":"Room_link__Do5rP"};